import { render } from "./Applications.vue?vue&type=template&id=ef47f060&scoped=true"
import script from "./Applications.vue?vue&type=script&lang=js"
export * from "./Applications.vue?vue&type=script&lang=js"

import "./Applications.vue?vue&type=style&index=0&id=ef47f060&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ef47f060"]])

export default __exports__